import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Checkout from "./pages/Checkout";
import ProtectedScanner from "./pages/ProtectedScanner";
import ProtectedScanner2 from "./pages/ProtectedScanner2";
import ProtectedAdmin from "./pages/ProtectedAdmin";
import Cam from "./pages/Cam";
import HostItDowntown from "./pages/HostItDowntown";
import Shop from "./shop/Shop";
import ShopCheckout from "./shop/ShopCheckout";

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={
                        <Home />
                    } />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/shop/checkout" element={<ShopCheckout />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/scanner" element={<ProtectedScanner />} />
                    <Route path="/scanner2" element={<ProtectedScanner2 />} />
                    <Route path="/admin" element={<ProtectedAdmin />} />
                    <Route path="/cam" element={<Cam />} />
                    <Route path="/host-it-downtown" element={<HostItDowntown />} />
                    <Route path="/:citySlug" element={<Home />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
